import { IdFuncs } from '../../../common/core/id/id.funcs';
import { NodeWire } from '../../../external/server/node.wire';

function init(node: Partial<NodeWire>): NodeWire {
  node.id = node.id ?? IdFuncs.generate();
  return node as NodeWire;
}

export const NodeWireFuncs = { init };
